module.exports = __webpack_public_path__ + "img/2.d49ee638.jpg";